
  <app-section>
    <app-back-navigation-btn [routeUrl]="backNavigation"></app-back-navigation-btn>
  </app-section>
  <app-component-seperator></app-component-seperator>
  <app-section>
    <app-page-header [title]="displayName">
      <span class="sub-details" *ngIf="updatedByObj && updatedByObj.updatedOn">
        Updated on
        <span class="value"> {{ updatedByObj.updatedOn | datePipe }}</span>  by
        <span class="updatedby">{{ updatedByObj.updatedBy }}</span>
      </span>
    </app-page-header>
  </app-section>
  <app-component-seperator></app-component-seperator>
  <app-tabs appStickyTop [tabs]="tabs" (onTabObjSelect)="onTabSelection($event)" [selectedTab]="getSelectedTab()"></app-tabs>
  <div class="tab-container" *ngIf="displayName">
      <router-outlet></router-outlet>
  </div>
